/**
 *  Poster
 *  Author: Luke
 *  CreatedAt: 2021-03-08
 */
import React from 'react';

import LinkImgDraggableDisplay from '@/src/components/LinkImgDraggableDisplay';
import LinkImage from '@/src/constrains/LinkImg';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import { Select } from 'src/components/Antd';

import {
  EnumCarouselOptions,
  PostOptions,
  generateLinkImg,
  optionsToNum,
} from '@/src/pages/SalesChannelContentEditor/common';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const Poster = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    droppableId,

    onItemAdd,
    onItemChange,
    onItemSort,
    onStaticChange,
    //To Do Delete Link Temp
    linkSet,
    staticData,
    linkModules,
    specificError,
    handleOnItemReduce,
    disabled,
    hideEdit,
  } = props; //onChange内容改变返回index+改变对象,amountOnChange数量改变返回整个数组

  const { posterType } = staticData;

  const handleOnPosterTypeChange = (e) => {
    if (onStaticChange) {
      onStaticChange({ posterType: e });
    }
    const _n = optionsToNum[e] || 1;
    if (linkModules.length > _n) {
      if (handleOnItemReduce) {
        handleOnItemReduce(linkModules.slice(0, _n));
      }
      // setPosters(linkModules.redux(0, _n));
    } else {
      const _v = generateLinkImg(_n - linkModules.length);
      if (onItemAdd) {
        onItemAdd(_v);
      }
    }
  };

  const handleOnItemChange = (index, obj) => {
    if (onItemChange) {
      onItemChange(index, obj);
    }
  };

  const handleOnItemSort = (from, to) => {
    if (onItemSort) {
      onItemSort(from, to);
    }
  };

  const _p = React.useMemo(() => {
    if (posterType === EnumCarouselOptions.One) {
      const _d = linkModules[0] || {};
      const { linkImage, uuid, linkType, label, action, draggableId } = _d;
      const imageErrorArray =
        specificError[`${draggableId}linkImageError`] || [];
      const linkTypeErrorArray =
        specificError[`${draggableId}linkTypeError`] || [];

      return (
        <LinkImage
          imageErrorArray={imageErrorArray}
          linkTypeErrorArray={linkTypeErrorArray}
          linkSet={linkSet}
          linkImage={linkImage}
          link={{ linkType, uuid, label, action }}
          title={`${getI18n('general.tools_helper.image')} ${1}`}
          subtitle={getI18n('general.checkImgDraggableDisplay.subtitle')}
          linkOnChange={(link) => {
            if (handleOnItemChange) {
              handleOnItemChange(0, link);
            }
          }}
          imgOnChange={(img) => {
            if (handleOnItemChange) {
              handleOnItemChange(0, { linkImage: img });
            }
          }}
          disabled={disabled}
          hideEdit={hideEdit}
        />
      );
    } else {
      return (
        <LinkImgDraggableDisplay
          error={specificError}
          linkSet={linkSet}
          droppableId={droppableId || 'CarouselDropZone'}
          data={linkModules}
          hideAdd
          onSort={handleOnItemSort}
          onChange={handleOnItemChange}
          disabled={disabled}
        />
      );
    }
  }, [linkModules, specificError]);

  return (
    <React.Fragment>
      <Section bottomBorder>
        <ItemWrapper title={getI18n('general.type')}>
          <Select
            size='large'
            optionsList={PostOptions}
            onChange={handleOnPosterTypeChange}
            value={posterType}
            disabled={disabled}
          />
        </ItemWrapper>
      </Section>
      {_p}
    </React.Fragment>
  );
};
export default Poster;
